var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:({
      src: './static/img/footer_pc.png',
      error: './static/img/footer_pc.png'
    }),expression:"{\n      src: './static/img/footer_pc.png',\n      error: './static/img/footer_pc.png'\n    }",arg:"background-image"}],staticClass:"pc_footer"},[_vm._v("\n    捷安特（昆山）有限公司\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39fe6685","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageFooter.vue
// module id = null
// module chunks = 